import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaCheckCircle } from "react-icons/fa";
import "../component/css/missioncomponent.css";

function MissionComponent() {
  return (
    <div
      style={{
        color: "coral",
        fontSize: "16px",
        padding: "30px",
        marginTop: "10px",
        width: "100%",
        textAlign: "center",
      }}
    >
      <Container>
        <Row>
          <Col>
            <h1
              className="text-center"
              style={{ fontWeight: "bold", marginBottom: "20px" }}
            >
              Mission Of YaaSaai
            </h1>
          </Col>
        </Row>
        <Row>
          <Col style={{ width: "100%" }}>
            <Card
              style={{
                border: "1px solid coral",
                padding: "16px",
                borderRadius: "10px",
                width: "100%",
                textAlign: "justify",
                color: "coral",
                background:
                  "linear-gradient(135deg, #ffd1dc, #ffe4e1, #fff0f5)",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
              }}
            >
              <Card.Body>
                <Row>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Convenience:</strong> Fresh vegetables & fruits at
                    your doorstep.
                  </Col>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Affordable Prices:</strong> Quality products at
                    reasonable rates.
                  </Col>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Home Delivery:</strong> Hassle-free and timely
                    service.
                  </Col>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Wide Variety:</strong> A diverse selection of fresh
                    produce.
                  </Col>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Customer Satisfaction:</strong> Easy returns for
                    unhappy purchases.
                  </Col>
                  <Col md={6} lg={4} className="mission_points">
                    <FaCheckCircle style={{ color: "coral" }} />{" "}
                    <strong>Healthy Living:</strong> Encouraging fresh & organic
                    food choices.
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default MissionComponent;
